import { render, staticRenderFns } from "./BaseChannelForm.vue?vue&type=template&id=2cf403f4&scoped=true&"
import script from "./BaseChannelForm.vue?vue&type=script&lang=js&"
export * from "./BaseChannelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf403f4",
  null
  
)

export default component.exports